module.exports = __webpack_public_path__ + "static/media/uncheck.95f83e2c.png";